import { ProductResourceImage } from "./Product";
import { Language } from "./Settings";

export interface GiftshopPricegroup {
    id: string;
    amount: number;
    image: string;
    type: GiftshopPricegroupType;
    products: GiftshopPricegroupProduct[];
}

export enum GiftshopPricegroupType {
    UNSET,
    CHRISTMAS,
    ANNIVERSARY
}

export interface GiftshopPricegroupProduct extends GiftshopProduct {
    featured: boolean;
}

export interface GiftshopLoginRequest {
    username: string;
    password: string;
    key: string;
}

export enum GiftshopLoginResponse {
    ERROR,
    SUCCESS,
    NOT_FOUND,
    OPENING_SOON,
    EXPIRED,
}

export interface GiftshopSelectionViewModel {
    name: string;
    logo: string;
    welcomemessage: string;
    thankyoumessage: string;
    checkoutinformationitems: GiftshopCheckoutInformationItem[];
    order: GiftshopOrder;
    products: GiftshopProduct[];
    languages: Language[];
    demomode: boolean;
}

export interface GiftshopCheckoutInformationItem {
    id: string;
    type: GiftshopCheckoutInformationItemType;
    name: string;
    values: GiftshopCheckoutInformationItemValue[];
}

export enum GiftshopCheckoutInformationItemType {
    TEXT,
    EMAIL,
    CHECKBOX,
    RADIO,
    SELECT
}

export interface GiftshopCheckoutInformationItemValue {
    id: string;
    value: string;
}

export interface GiftshopOrder {
    product: string;
    checkoutinformation: { [key: string]: string; };
}

export interface GiftshopProduct {
    id: string;
    name: string;
    shortdescription: string;
    longdescription: string;
    video: string;
    images: ProductResourceImage[];
    dimension1images: { [key: string]: ProductResourceImage[]; };
    variants: GiftshopVariant[];
    featured: boolean;
}

export interface GiftshopVariant {
    id: string;
    name: string;
    shortdescription: string;
    longdescription: string;
    images: ProductResourceImage[];
    dimensioncount: number;
    dimension1code: string;
    dimension1label: string;
    dimension2code: string;
    dimension2label: string;
    group1code: string;
    group1label: string;
    group2code: string;
    group2label: string;
}

export interface GiftshopOrderEditModel {
    product: string;
    checkoutinformation: { [key: string]: string; };    
}

export interface GiftshopEditModel {
    name: string;
    pricegroups: string[];
    products: string[];
    company: string;
    contactname: string;
    contactphone: string;
    contactemail: string;
    wrapping: boolean;
}